<template>
    <a-card>
        <a-page-header title='广告主分组管理' />
        <a-row type="flex" justify="start" :wrap="true">
            <a-col class="column-items">
                广告主状态：
                <a-select ref="select" v-model="searchParams.status" style="width: 200px">
                    <a-select-option :value="1">开启</a-select-option>
                    <a-select-option :value="2">关闭</a-select-option>
                </a-select>
            </a-col>
            <a-col class="column-items">
                广告主：
                <a-input style="width: 200px" v-model.trim="searchParams.advertiserName" placeholder="请输入广告主名称" allowClear
                    :maxLength="100">
                    {{ searchParams.advertiserName }}
                </a-input>
            </a-col>
            <a-col class="column-items"><a-button type="primary" style="width: 160px;" :loading="searchingLoading"
                    @click="handleSearch">查询</a-button></a-col>
        </a-row>
        
        <a-row>
            <a-button type="default" style="margin: 0 0 20px 20px; width: 160px;" @click="handleJumpManager">分组管理</a-button>
        </a-row>

        <a-table bordered :loading="tableLoading" :columns="columns" :data-source="dataList"
            :row-key="(record, index) => index" :pagination='false'>
            <div slot="group" slot-scope="text, record">
                <a-select v-model="record.advertiserGroupId" style="width: 260px" placeholder="请选择">
                    <a-select-option v-for="(value, index) in groupList" :value="value.id" :key="index">
                        {{ value.advertiserGroupName }}
                    </a-select-option>
                </a-select>
            </div>
            <div slot="action" slot-scope="text, record">
                <a-button :loading="btnLoading" type="primary" style="width: 100px;margin-right: 15px;"
                    @click="handleSave(record)">保存</a-button>
                <a-button @click="handleReset(record)">重置</a-button>
            </div>
        </a-table>

        <base-pagination :currentPage="pagination.current" :pageSize="pagination.pageSize" :total="pagination.total"
            @onChange="handlePaginationChange" @onShowSizeChange="handlePaginationChange" />
    </a-card>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
    data() {
        const columns = [
            {
                align: 'center',
                title: '广告主',
                width: 300,
                dataIndex: 'advertiserName',
                customRender(text) {
                    return text || '-'
                },
            },
            {
                align: 'center',
                title: '品牌',
                width: 260,
                dataIndex: 'principalName',
                customRender: (text, row) => {
                    return text || '-'
                }
            },
            {
                align: 'center',
                title: '广告组分组',
                key: 'group',
                scopedSlots: { customRender: 'group' }
            },
            {
                align: 'center',
                title: '操作',
                key: 'action',
                width: 245,
                fixed: 'right',
                scopedSlots: { customRender: 'action' }
            }
        ]
        return {
            searchParams: {
                status: 1,
                advertiserName: undefined
            },
            searchingLoading: false,
            tableLoading: false,
            btnLoading: false,
            groupList: [],
            dataList: [],
            columns,
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            },
        }
    },
    created() {
        this.getGroupList()
        this.getDataList()
    },
    methods: {
        async getGroupList() {
            const { code, data, message } = await this.$api.core.pphtManage.getAdvGroupManageList({ size: 800 }).finally(() => {
                this.tableLoading = false
            })
            if (code === 200) {
                this.groupList = data.list
            } else {
                console.error(`获取组别列表失败: ${message}`)
            }
        },
        async getDataList() {
            this.tableLoading = true
            const params = Object.assign({}, this.searchParams, {
                page: this.pagination.current,
                size: this.pagination.pageSize
            })
            const { data, code, message } = await this.$api.core.pphtManage.getAdvGroup(params).finally(() => {
                this.tableLoading = false
            })
            if (code === 200) {
                this.dataList = data.list.map((v) => {
                    // 未选分组
                    if (!v.advertiserGroupId) v.advertiserGroupId = undefined
                    return v
                })
                this.pagination.total = data.total || 0
            } else {
                console.error(`获取列表失败: ${message}`)
            }
        },
        handleSearch: debounce(function () {
            this.pagination.page = 1
            this.getDataList()
        }, 1000, { 'leading': true }),
        async handleSave({ advertiserId, advertiserGroupId }) {
            this.btnLoading = true
            const params = {
                advertiserId,
                advertiserGroupId: advertiserGroupId || null
            }
            const { code, message } = await this.$api.core.pphtManage.updateAdvBindGroup(params).finally(() => {
                this.btnLoading = false
            })
            if (code === 200) {
                this.$message.success('修改成功')
            } else {
                this.$message.error(`修改失败：${message}`)
            }
        },
        handleReset(data) {
            data.advertiserGroupId = undefined
        },
        handlePaginationChange(current, pageSize) {
            this.pagination.current = current
            this.pagination.pageSize = pageSize
            this.getDataList()
        },
        handleJumpManager() {
            this.$router.push({ name: 'pphtManage:advGroupList' })
        }
    }
}
</script>

<style scoped lang="less">
.column-items {
    margin: 0 0 20px 20px;
}
</style>